<script setup>
import { formatShortDate } from '@/lib/utils'

import { useCurrencyColumnFormatter } from '@/composables/data-grid'
import { useChips } from '@/composables/chips'

import ListItem from '@/components/shared/ListItem.vue'
import ChipTemplate from '@/components/shared/ChipTemplate.vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['click'])

const { getInvoiceStatusChips, getProjectChips } = useChips()
</script>

<template>
  <q-item>
    <list-item
      :key="item.id"
      class="q-pa-sm"
      hide-avatar
      :caption-chips="getProjectChips(item.projects)"
      dense
      clickable
      @click="emit('click', props.item)"
    >
      <template #label>
        <q-item-label class="text-left">
          {{ [item.invoice_number, item.company_name].filter(Boolean).join(' - ') }}
        </q-item-label>
      </template>
      <template #right>
        <q-item-section
          avatar
          class="align-middle align-center q-px-none"
        >
          <q-item-label class="row items-center no-wrap q-gutter-x-xs">
            <chip-template :values="getInvoiceStatusChips(item.status)" size="xs" />
            <span>{{ useCurrencyColumnFormatter(item, 'total_vat', item.currency_ref) }}</span>
          </q-item-label>
          <q-item-label caption class="text-left align-items-baseline">
            <q-icon name="mdi-calendar" class="q-mr-xs" />
            <span>{{ formatShortDate(item.date) }}</span>
          </q-item-label>
        </q-item-section>
      </template>
    </list-item>
  </q-item>
</template>
